const { styled } = require("@mui/material");
import { Modal, Card, CardContent, Stack } from "@mui/material";
import { typographyClasses } from "@mui/material/Typography";
import { cardActionsClasses } from "@mui/material/CardActions";
import { cardContentClasses } from "@mui/material/CardContent";

export const MembershipModal = styled(Modal)({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
});

export const MembershipCard = styled(Card)(({ theme }) => ({
  outline: "none",
  width: "400px",
  backgroundColor: theme.palette.supportiveDustyBlue.main,
  [`& .${typographyClasses.subtitle1}`]: {
    color: theme.palette.secondary.main,
    marginBottom: 8,
  },
  [`& .${cardContentClasses.root}`]: {
    padding: 0,
  },
  [`& .${cardActionsClasses.root}`]: {
    padding: 0,
  },
}));

export const MembershipStack = styled(Stack)({
  padding: 32,
});

export const MembershipCardContent = styled(CardContent)(({ theme }) => ({
  color: theme.palette.white.main,
}));
